import { OverlapSuppressionFilterType } from "~frontend/__generated__/graphql";

const filterLabels: { [K in OverlapSuppressionFilterType]: string } = {
  [OverlapSuppressionFilterType.MessageSent]: "Sent Messages",
  [OverlapSuppressionFilterType.MessageNotSent]: "Unsent Messages",
  [OverlapSuppressionFilterType.Replied]: "Contacts Who Replied",
  [OverlapSuppressionFilterType.DidNotReply]: "Contacts Who Didn't Reply",
  [OverlapSuppressionFilterType.Donated]: "Contacts Who Donated",
  [OverlapSuppressionFilterType.RepliedAndDonated]:
    "Contacts Who Replied AND Donated",
  [OverlapSuppressionFilterType.Tagged]: "Contacts who were tagged with...",
};

export default filterLabels;
